module.exports = __webpack_public_path__ + "static/media/all-roads-north.1f90a416.jpg";